export default __webpack_public_path__ + "19834f9acf7f4534077d347a3b606772.svg";